(() => {
  const selector = {
    slider: '.productGallery__slider',
    productGallery: '.productGallery',
    header: '.section-header',
  }
  const header = document.querySelector(selector.header);
  const productGallery = document.querySelector(selector.productGallery);
  const slickSettings = {
    infinite: false,
    dots: true,
    arrows: false,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: 'unslick'
      },
    ],
  };

  document.addEventListener('scroll', (e) => {
   if (header.classList.contains('scroll')){
      productGallery.style.top = "75px";
    } else {
      productGallery.style.top = "25px";
    }
  })

  $(selector.slider).slick(slickSettings);

  window.addEventListener('resize', () => {
    $(selector.slider).slick('resize');
  });
})();